import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full h-[600px] md:h-[720px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20creative%20agency%20workspace%20with%20warm%20ambient%20lighting%20and%20artistic%20abstract%20geometric%20shapes%20floating%2C%20coral%20orange%20and%20gold%20color%20gradient%20atmosphere%2C%20professional%20yet%20creative%20vibe%2C%20cinematic%20depth%20of%20field%2C%20warm%20minimal%20aesthetic%20with%20soft%20textures&width=1920&height=1080&seq=hero-bg-main&orientation=landscape"
          alt="果冻传媒 - 创意内容营销与品牌传播平台"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-5 md:mb-6">
            {t('heroTitle')}
          </h1>
          <p className="text-base md:text-lg text-white/80 leading-relaxed mb-8 md:mb-10 max-w-2xl mx-auto">
            {t('heroSubtitle')}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/about#contact"
              className="px-8 py-3 bg-primary-500 text-white rounded-full text-sm font-medium hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              {t('heroCTA')}
            </Link>
            <Link
              to="/category/short-video"
              className="px-8 py-3 bg-white/15 text-white backdrop-blur-sm rounded-full text-sm font-medium hover:bg-white/25 border border-white/30 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              {t('viewAll')}
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-white/60 text-2xl"></i>
      </div>
    </section>
  );
}